import {
  ref,
  defineComponent,
  onMounted,
  nextTick,
  onBeforeUnmount,
  computed,
} from 'vue';
import type { OfferListBlockContent } from '~/interfaces/constructor';
import StickerMarker from '~/components/ui/sticker-marker/StickerMarker.vue';
import { useAnalyticsStore } from '~/stores/analytics';
import cpcLink from '~/components/ui/CpcLink.vue';
import responsiveImage from '~/components/ui/ResponsiveImage.vue';
import currency from '~/components/ui/currency/Currency.vue';

export default defineComponent({
  name: 'Custom',
  components: {
    StickerMarker,
    cpcLink,
    responsiveImage,
    currency,
  },
  props: {
    data: {
      type: Object as () => OfferListBlockContent,
      required: true,
    },
  },
  emits: ['promo-banner-click'],
  setup(props) {
    const { $ymAnyEvent } = useNuxtApp();
    const analyticsStore = useAnalyticsStore();
    const card = ref<HTMLElement | undefined>();
    const sendEvents = (data: {
      to?: string;
      image?: string;
      gtag?: any;
      ym_event?: { tag: string };
    }) => {
      $ymAnyEvent('reachGoal', data?.ym_event?.tag);
    };

    const isBanner = computed(() => !!props.data.banner);

    onMounted(() => {
      nextTick(() => {
        observeElements();
      });
    });

    onBeforeUnmount(() => {
      observeElements(true);
    });

    function observeElements(unobserve = false) {
      const list: NodeListOf<Element> | undefined =
        card.value?.querySelectorAll('.item:not(.item__skeleton)');
      if (list?.length && list.forEach instanceof Function) {
        (list as NodeListOf<HTMLElement>).forEach((e: HTMLElement) => {
          unobserve
            ? analyticsStore.unobserveView(e)
            : analyticsStore.observeView(e);
        });
      }
    }

    function advertising(item: {
      shop_info: {
        site: string;
      };
    }) {
      return item?.shop_info?.site?.split('//')[1] || '';
    }

    return {
      card,
      observeElements,
      advertising,
      isBanner,
      sendEvents,
    };
  },
});
